export default __webpack_public_path__ + "static/media/error.de519473.svg";